import { SCORECARD_STATUS } from 'talent_search/shared/types';

import AdvancedFilter from 'talent_matching/components/filters/advanced_filter';
import { DEFAULT_PAGE_SIZE } from 'talent_matching/page_size_options';
import type { TalentMatchingFilters } from 'talent_matching/types';

export const FORM_DEFAULTS: TalentMatchingFilters = {
  page: 1,
  perPage: DEFAULT_PAGE_SIZE,
  hideRejected: false,
  jobAlertSubscribers: false,
  feedbackStatus: SCORECARD_STATUS.ALL,
  tags: [],
  locationFilterType: 'radius',
  locationName: '',
  debouncedLocationName: '',
  geolocation: null,
  geolocationRadius: '5',
  degrees: [],
  disciplines: [],
  schools: [],
  appliedOnStart: null,
  appliedOnEnd: null,
  appliedOnType: null,
  jobPosts: [],
  excludePreviouslyRejected: false,
  priorityCandidates: false,
  advancedFilters: [new AdvancedFilter()],
  excludedIds: [],
  savedForLater: null,
  bookmarkedByTeammates: [],
  manualReview: false,
  excludeHighRisk: false,
  otherActiveApplications: null,
  minExperience: null,
  maxExperience: null,
  companyNameFilters: [],
  educationFilters: [],
  canHave: [],
  mustHave: [],
  doesNotHave: [],
  questionFilters: [],
};
